const pageNameKey = "otaFirmwareVersionDrawerModal";

export const otaFirmwareVersionDrawerModalEn = {
  [pageNameKey]: {
    releaseNewFirmwareText: "Release New Firmware",
    releaseFirmwareDetailsText: "Firmware Details",
    releaseFirmwareText: "Release",
    cancelText: "Cancel",
    fixValidateFieldText: "Please fix following fields: ",
    uploadFailedText: "Something went wrong while uploading firmware.",
  },
};

export const otaFirmwareVersionDrawerModalPtBr = {
  [pageNameKey]: {
    releaseNewFirmwareText: "Lançar novo firmware",
    releaseFirmwareDetailsText: "Detalhes do firmware",
    releaseFirmwareText: "Versão",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrija os seguintes campos: ",
    uploadFailedText: "Algo deu errado ao enviar o firmware.",
  },
};

export const otaFirmwareVersionDrawerModalDe = {
  [pageNameKey]: {
    releaseNewFirmwareText: "Neue Firmware veröffentlichen",
    releaseFirmwareDetailsText: "Firmware-Details",
    releaseFirmwareText: "Freigeben",
    cancelText: "Stornieren",
    fixValidateFieldText: "Bitte korrigieren Sie die folgenden Felder:",
    uploadFailedText: "Beim Hochladen der Firmware ist ein Fehler aufgetreten.",
  },
};

export const otaFirmwareVersionDrawerModalZhHans = {
  [pageNameKey]: {
    releaseNewFirmwareText: "发布新固件",
    releaseFirmwareDetailsText: "固件详细信息",
    releaseFirmwareText: "发布",
    cancelText: "取消",
    fixValidateFieldText: "请更正以下字段：",
    uploadFailedText: "固件上传过程中出现错误。",
  },
};

export const otaFirmwareVersionDrawerModalIt = {
  [pageNameKey]: {
    releaseNewFirmwareText: "Crea nuovo firmware",
    releaseFirmwareDetailsText: "Dettagli del firmware",
    releaseFirmwareText: "Crea",
    cancelText: "Annulla",
    fixValidateFieldText: "Correggi i seguenti campi: ",
    uploadFailedText:
      "Si è verificato un errore durante il caricamento del firmware.",
  },
};

export const otaFirmwareVersionDrawerModalEs = {
  [pageNameKey]: {
    releaseNewFirmwareText: "Lanzar nuevo firmware",
    releaseFirmwareDetailsText: "Detalles del firmware",
    releaseFirmwareText: "Lanzar",
    cancelText: "Cancelar",
    fixValidateFieldText: "Por favor, corrige los siguientes campos: ",
    uploadFailedText: "Se produjo un error al cargar el firmware.",
  },
};

export const otaFirmwareVersionDrawerModalNl = {
  [pageNameKey]: {
    cancelText: "Annuleren",
    fixValidateFieldText: "Corrigeer de volgende velden: ",
    releaseFirmwareDetailsText: "Firmwaredetails",
    releaseFirmwareText: "Uitgeven",
    releaseNewFirmwareText: "Nieuwe firmware uitgeven",
    uploadFailedText:
      "Er is een fout opgetreden tijdens het uploaden van de firmware.",
  },
};

export const otaFirmwareVersionDrawerModalTr = {
  [pageNameKey]: {
    cancelText: "İptal etmek",
    fixValidateFieldText: "Lütfen aşağıdaki alanları düzeltin:",
    releaseFirmwareDetailsText: "Aygıt Yazılımı Ayrıntıları",
    releaseFirmwareText: "Serbest bırakmak",
    releaseNewFirmwareText: "Yeni Firmware'i Yayınlayın",
    uploadFailedText: "Firmware yüklenirken bir şeyler ters gitti.",
  },
};
